import { createBrowserHistory } from 'history';

/**
 * BrowserHistory.
 */
export default createBrowserHistory();
